class HeritageTimeline extends HTMLElement {
  connectedCallback() {
    const nav = this.querySelector('.heritage-timeline__nav');
    const anchors = this.querySelectorAll('.heritage-timeline__item[id]');
    if (!nav || !anchors.length) return;

    const realLinks = Array.from(nav.querySelectorAll('.heritage-timeline__nav-link'));
    if (!realLinks.length) return;

    requestAnimationFrame(() =>
      requestAnimationFrame(() => {
        const setWidth = realLinks.reduce((sum, l) => sum + l.offsetWidth, 0);
        const overflows = setWidth > nav.clientWidth;

        let firstLeft = realLinks[0].offsetLeft;
        let autoScrolling = false;
        let autoScrollTimer;

        // ── Infinite carousel (only when the real links overflow the nav) ──
        if (overflows) {
          const makeClones = () =>
            realLinks.map((l) => {
              const c = l.cloneNode(true);
              c.setAttribute('aria-hidden', 'true');
              c.setAttribute('tabindex', '-1');
              return c;
            });

          makeClones().forEach((c) => nav.appendChild(c));

          firstLeft = realLinks[0].offsetLeft;

          nav.scrollLeft = 0;

          // Forward-only infinite jump — paused while auto-centering
          nav.addEventListener(
            'scroll',
            () => {
              if (autoScrolling) return;
              const sl = nav.scrollLeft;
              if (sl > firstLeft + setWidth + 10) {
                nav.scrollLeft = sl - setWidth;
              }
            },
            { passive: true }
          );
        }

        // ── Active-year observer ───────────────────────────────────────────
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;

              const id = entry.target.getAttribute('id');

              // Only operate on real links — clones are ignored
              realLinks.forEach((l) =>
                l.classList.toggle('is-active', l.getAttribute('href') === `#${id}`)
              );

              const active = realLinks.find((l) => l.classList.contains('is-active'));
              if (!active) return;

              // Center active link in nav without touching page scroll
              const navRect = nav.getBoundingClientRect();
              const linkRect = active.getBoundingClientRect();
              const target =
                nav.scrollLeft +
                linkRect.left -
                navRect.left -
                navRect.width / 2 +
                linkRect.width / 2;

              autoScrolling = true;
              clearTimeout(autoScrollTimer);
              nav.scrollTo({
                left: Math.max(0, Math.min(target, nav.scrollWidth - nav.clientWidth)),
                behavior: 'smooth',
              });
              autoScrollTimer = setTimeout(() => {
                autoScrolling = false;
              }, 600);
            });
          },
          { rootMargin: '-10% 0px -80% 0px' }
        );

        anchors.forEach((el) => observer.observe(el));
      })
    );
  }
}

customElements.define('heritage-timeline', HeritageTimeline);
